module.exports = __webpack_public_path__ + "static/img/qualifications_row_11.a0b3f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_11.png
// module id = kzCi
// module chunks = 1